export const PUBLISHERS_REQUEST = 'PUBLISHERS_REQUEST'
export const PUBLISHERS_REPLACE = 'PUBLISHERS_REPLACE'
export const PUBLISHER_SAVE = 'PUBLISHER_SAVE'
export const PUBLISHER_GET_NEW_ID = 'PUBLISHER_GET_NEW_ID'
export const PUBLISHER_UPDATE = 'PUBLISHER_UPDATE'
export const PUBLISHERS_SUCCESS = 'PUBLISHERS_SUCCESS'